import angular from 'angular'
import template from './template.html'

angular.module('nominas.cargacontpaq')
  .component('nominasCargacontpaq', {
    template: template,
    controller: NominasCargacontpaqComponent,
    bindings: {
      idProyecto: '<',
      idNomina: '<',
      onClose: '<',
    },
  });

function NominasCargacontpaqComponent($state) {
  let $ctrl = this;

  $ctrl.aceptar = aceptar;
  $ctrl.calcular = calcular;
  $ctrl.data = null;

  function aceptar(data) {
    if (!data) {
      $ctrl.data = null;

      return;
    }

    $state.go('nominas.detalladoNomina.colaboradores', {
      idEmpresa: $ctrl.idProyecto,
      idNomina: $ctrl.idNomina,
    }, {reload: true});
  }

  function calcular(data) {
    $ctrl.data = data;
  }
}



// WEBPACK FOOTER //
// ./src/nominas/cargacontpaq/components/component.js